
/**
 * Export from global variable `_config` which contains the config injected by
 * the koa server.
 */

export default _config; // eslint-disable-line no-undef



// WEBPACK FOOTER //
// ../src/client/core/client-config/index.js